// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__30e5K","head":"ProcedureTableInfo_head__3gg7v"};